import { render, staticRenderFns } from "./resourceDetails.vue?vue&type=template&id=d5238434&scoped=true"
import script from "./resourceDetails.vue?vue&type=script&lang=js"
export * from "./resourceDetails.vue?vue&type=script&lang=js"
import style0 from "./resourceDetails.vue?vue&type=style&index=0&id=d5238434&prod&lang=scss&scoped=true"
import style1 from "./resourceDetails.vue?vue&type=style&index=1&id=d5238434&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5238434",
  null
  
)

export default component.exports